module.exports = __webpack_public_path__ + "img/timer.861f4fb9.png";